import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

// DOMPurify v3 exports a factory; call it with window to get the sanitizer
const createDOMPurify = require('dompurify');
const purify = createDOMPurify(window);

@Pipe({ name: 'markdown' })
export class MarkdownPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    const html = marked(value) as string;
    return purify.sanitize(html);
  }
}
